import { Autocomplete, Button, CircularProgress, Divider, FormLabel, Grid, IconButton, MenuItem, Select, TableCell, TextField, Typography } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTicketStore } from "../../hooks/useTicketStore";
import { Ticket } from "../../types/slices/ticketType";
import { DocumentInfo } from "./components/DocumentInfo";
import { DocumentDetail } from "./components/DocumentDetail";
import { useSoftnetStore } from "../../hooks/useSoftnetStore";
import { RoutesMap } from "../../types";
import { ApiStatus } from "../../types/api/status";
import HeaderV3 from "../SearcherV3/components/HeaderV3";
import { useWayToPayStore } from "../../hooks/useWayToPayStore";
import { useBussinesAreaStore } from "../../hooks/useBussinesAreaStore";
import { useDocumentOfSalesStore } from "../../hooks/useDocumentOfSalesStore";
import { useSellerStore } from "../../hooks/useSellerStore";
import { onSetSelectedSeller } from "../../redux/slices/sellerSlice";
import { useSearcherStore } from "../../hooks/useSearcherStore";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { CustomSnackbar } from "../../components/common/CustomSnackbar/CustomSnackbar";
import { useSupplierStore } from "../../hooks/useSupplierStore";
import { useAccountReceivableStore } from "../../hooks/useAccountReceivableStore";
import { useAuthStore } from "../../hooks/useAuthStore";
import { Reference } from "../Order/components/drawers/IssueDrawer";

export const PreviewDocument: FC = () => {
    const navigate = useNavigate();
    const params = useParams()
    const { id } = params
    const idticket: any = id

    // const location = useLocation();
    // const data = location.state ? location.state.data : null;

    const { user } = useAuthStore()
    const { status: statusTicket, tickets, getTicket, confirmTicket } = useTicketStore()
    const { status, createSalesDocument } = useSoftnetStore()
    const { getWayToPayByCompany } = useWayToPayStore()
    const { status: statusBussines, bussinesArea, getBussinesAreaByCompany } = useBussinesAreaStore()
    const { getDocumentOfSalesByCompany } = useDocumentOfSalesStore()
    const { getSellers } = useSellerStore()
    const { selectedCustomer, setSelectedCustomer } = useSearcherStore()
    const { status: statusSupplier, getSuppliers, editSupplier } = useSupplierStore()
    const { createAccountReceivable } = useAccountReceivableStore()

    const [ticket, setTicket] = useState<Ticket | null>(null)
    const [paymentMethods, setPaymentMethods] = useState<any>([])
    const [salesDocument, setSalesDocument] = useState<any>([])
    const [sellers, setSellers] = useState<any>([])

    const [selectedWayToPay, setSelectedWayToPay] = useState<any>(null)
    const [selectedBussines, setSelectedBussines] = useState<any>(null)
    const [documentSelected, setDocumentSelected] = useState<any>(null)
    const [sellerSelected, setSellerSelected] = useState<any>(null)
    const [showSaveSettingModal, setShowSaveSettingModal] = useState<boolean>(false)
    const [consultedConfiguration, setConsultedConfiguration] = useState<boolean>(false)
    const [loadingSaveTicket, setLoadingSaveTicket] = useState<boolean>(false)
    const [loadingData, setLoadingData] = useState<boolean>(false)
    const [nInterno, setNInterno] = useState<string>('')
    const [ordenCompra, setOrdenCompra] = useState<string>('')
    const [references, setReferences] = useState<Reference[]>([])

    const isClient: boolean = user?.userType === 'Cliente'

    useEffect(() => {
        getDataApi()
    }, [])

    useEffect(() => {
        setTicket(tickets[0])
    }, [tickets])

    useEffect(() => {
        if (ticket && paymentMethods.length > 0) {
            const wayToPay = paymentMethods.find(row => row.id === ticket.idway_to_pay)
            setSelectedWayToPay(wayToPay || null)
        }
    }, [ticket, paymentMethods])

    useEffect(() => {
        if (ticket && bussinesArea.length > 0) {
            const selected = bussinesArea.find(row => row.iderp === ticket.bussines_area)
            setSelectedBussines(selected || null)
        }
    }, [ticket, bussinesArea])

    useEffect(() => {
        if (ticket && salesDocument.length > 0) {
            const selected = salesDocument.find(row => row.id === ticket.idtype_document)
            setDocumentSelected(selected || null)
        }
    }, [ticket, salesDocument])

    useEffect(() => {
        if (ticket && sellers.length > 0) {
            const selected = sellers.find(row => row.id == ticket.idsalesman)
            setSellerSelected(selected || sellers[0])
        }
    }, [ticket, sellers])

    useEffect(() => {
        if (!selectedCustomer && ticket?.idcustomer) getSupplierAPI(ticket?.idcustomer)
    }, [selectedCustomer, ticket])

    useEffect(() => {
        if (selectedCustomer?.idbussines_area && selectedCustomer?.idwaytopay) {
            setConsultedConfiguration(true)
        }
    }, [selectedCustomer])

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                event.preventDefault()
                document.getElementById("btnBack")?.click()
            }

            if (event.key === 'F12') {
                event.preventDefault()
                document.getElementById("btnSaveTicket")?.click()
            }

            if (event.ctrlKey && event.key === 'Enter') {
                event.preventDefault()
                document.getElementById("btnIssueTicket")?.click()
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => {
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [])

    useEffect(() => {
        if (bussinesArea.length > 0) {
            setSelectedBussines(bussinesArea[0])
        }
    }, [bussinesArea])

    const getDataApi = async () => {
        setLoadingData(true)
        await getTicket({ id: idticket, status: 0 })
        await getWayToPayApi()
        await getBussinesAreaByCompany()
        await getDocumentsApi()
        await getSellersAPI()
        setLoadingData(false)
    }

    const getWayToPayApi = async (search = '') => {
        try {
            const response = await getWayToPayByCompany(search);
            const newData: any = [];
            response && (response).length > 0 && (response).map((item) => {
                newData.push({
                    ...item,
                    idcuotas: JSON.parse(item.idcuotas),
                    idtools: JSON.parse(item.idtools),
                })
            })
            setPaymentMethods(newData || []);
        } catch (error) {
            console.log(error)
        }
    }

    const getDocumentsApi = async (search = '') => {
        try {
            const response = await getDocumentOfSalesByCompany(search);
            if (!response) {
                setSalesDocument([])
                return false;
            } else {
                setSalesDocument(response)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getSellersAPI = async (search = '') => {
        try {
            const response = await getSellers(search);
            if (!response) {
                setSellers([])
                return false;
            } else {
                setSellers(response)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getSupplierAPI = async (id: number) => {
        const resp = await getSuppliers({ id })
        if (resp?.detail[0]) {
            setSelectedCustomer(resp?.detail[0])
        }
    }

    const goBack = () => {
        navigate(-1)
    }

    const onCreateSalesDocument = async () => {
        if (!ticket) return
        if (!selectedBussines) return CustomSnackbar('warning', 'Seleccione un área de negocio')
        // if (observation === '') return CustomSnackbar('warning', 'Ingrese una observación')

        const response = await createSalesDocument(ticket.id, {
            idticket: ticket?.id,
            observation: 'OBS',
            bussines_area: selectedBussines?.iderp,
            automatic: true,
            idway_to_pay: selectedWayToPay?.idway_to_pay,
            idtype_document: documentSelected?.id,
            nInterno: nInterno || undefined,
            ordenCompra: ordenCompra || undefined,
            references: references.length > 0 ? references : undefined
        })
        if (response?.pdf) {
            navigate({ pathname: RoutesMap.SEARCHER_COMPANY })
            window.open(response.pdf, "_blank")
        }
    }

    const onConfirmTicket = async (id: number, isSaveConfiguration?: boolean) => {
        if (!selectedWayToPay) return CustomSnackbar('warning', 'Seleccione una forma de pago.')
        if (!selectedBussines) return CustomSnackbar('warning', 'Seleccione un área de negocio.')

        if (!isSaveConfiguration) {
            if (consultedConfiguration === false) return setShowSaveSettingModal(true)
        }
        setLoadingSaveTicket(true)

        const payload = {
            idtype_document: documentSelected?.id,
            idway_to_pay: selectedWayToPay?.idway_to_pay,
            bussines_area: selectedBussines?.iderp,
            idsalesman: sellerSelected?.id,
            n_internal: nInterno || undefined,
            purchase_order: ordenCompra || undefined,
        }

        const resp = await confirmTicket(id, payload)
        setLoadingSaveTicket(false)

        if (resp === true) {
            setSelectedCustomer(null)
            navigate({ pathname: RoutesMap.SEARCHER_COMPANY })
        }
    }

    const onSaveSetting = async () => {
        if (!selectedCustomer) return
        const resp = await editSupplier(selectedCustomer?.id, {
            idwaytopay: selectedWayToPay?.idway_to_pay,
            idbussines_area: selectedBussines?.id,
            idsalesman: sellerSelected?.id
        })
        if (resp === true) {
            await onConfirmTicket(idticket, true)
            setConsultedConfiguration(true)
            setShowSaveSettingModal(false)
        }
    }

    const handleUpdateReference = <K extends keyof Reference>(
        refIndex: number,
        field: K,
        value: Reference[K]
    ) => {
        setReferences(prev =>
            prev.map((ref, i) =>
                i === refIndex ? { ...ref, [field]: value } : ref
            )
        )
    }

    const handleAddReference = () => {
        setReferences(prev => [
            ...prev,
            { type: "HES", date: "", folio: "", reason: "" }
        ])
    }

    const handleRemoveReference = (refIndex: number) => {
        setReferences(prev => prev.filter((_, i) => i !== refIndex))
    }

    return (
        <>
            {/* <HeaderV3 /> */}
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                    <Typography sx={{ textAlign: 'center', fontSize: '22px' }}>PREVISUALIZACIÓN DEL DOCUMENTO</Typography>
                </Grid>

                {/* Información */}
                {ticket && <DocumentInfo ticket={ticket} idtype_document={ticket.idtype_document} />}

                {/* Detalle */}
                {ticket && <DocumentDetail ticket={ticket} idtype_document={ticket.idtype_document} />}

                <Grid item xs={12}><Divider /></Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                        id="idway_to_pay"
                        size="small"
                        value={selectedWayToPay || null}
                        options={paymentMethods || []}
                        getOptionLabel={(option) => option?.wayToPay || ''}
                        isOptionEqualToValue={(option, value) => option.wayToPay === value?.wayToPay}
                        renderInput={(params) =>
                            <TextField {...params} label="Forma de pago" size="small" />
                        }
                        onChange={(e, newValue: any) => {
                            setSelectedWayToPay(newValue)
                        }}

                    />
                </Grid>

                {!isClient && (
                    <Grid item xs={12} sm={6} md={3}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-bussines-area"
                            value={selectedBussines}
                            options={statusBussines === ApiStatus.FETCHING ? [] : bussinesArea}
                            getOptionLabel={(option) => option.name || ""}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            fullWidth
                            renderInput={(params) =>
                                <TextField {...params} label="Área de negocio" size="small"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {statusBussines === ApiStatus.FETCHING && <CircularProgress color="inherit" size={20} />}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            }
                            onChange={(e, newValue) => {
                                setSelectedBussines(newValue);
                            }}
                        />
                    </Grid>
                )}

                {!isClient && (
                    <Grid item xs={12} sm={6} md={3}>
                        <Autocomplete
                            id="idtype_document"
                            size="small"
                            value={!!documentSelected ? documentSelected : null}
                            options={salesDocument || []}
                            getOptionLabel={(option) => option?.name || ''}
                            isOptionEqualToValue={(option, value) => option.name === value?.name}
                            renderInput={(params) =>
                                <TextField {...params} label="Tipo de documento" size="small" />
                            }
                            onChange={(e, newValue: any) => {
                                setDocumentSelected(newValue)
                            }}

                        />
                    </Grid>
                )}

                {!isClient && (
                    <Grid item xs={12} sm={6} md={3}>
                        <Autocomplete
                            id="idsalesman"
                            size="small"
                            value={sellerSelected}
                            options={sellers || []}
                            getOptionLabel={(option) => option?.name + ' ' + option?.surname || ''}
                            isOptionEqualToValue={(option, value) => option.name === value?.name}
                            renderInput={(params) =>
                                <TextField {...params} label="Vendedor" size="small" />
                            }
                            onChange={(e, newValue: any) => {
                                setSellerSelected(newValue)
                            }}

                        />
                    </Grid>
                )}

                {!isClient && (<>
                    <Grid item xs={12} sx={{ marginTop: 2 }}>
                        <Divider>Datos adicionales</Divider>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            label="N° Interno"
                            value={nInterno}
                            onChange={(e) => setNInterno(e.target.value)}
                            fullWidth
                            margin="dense"
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            label="Orden de Compra"
                            value={ordenCompra}
                            onChange={(e) => setOrdenCompra(e.target.value)}
                            fullWidth
                            margin="dense"
                            size="small"
                        />
                    </Grid>
                </>)}


                {!isClient && (<>
                    <Grid item xs={12} sx={{ marginTop: 2 }}>
                        <Divider>Referencias</Divider>
                    </Grid>

                    {references.map((ref, refIndex) => (
                        <>
                            <Grid item xs={3}>
                                <Select
                                    fullWidth
                                    value={references[refIndex]?.type || ""}
                                    onChange={(e) => handleUpdateReference(refIndex, "type", e.target.value)}
                                    size="small"
                                >
                                    <MenuItem value="HES">HES</MenuItem>
                                    <MenuItem value="OT">OT</MenuItem>
                                    <MenuItem value="CON">CON</MenuItem>
                                </Select>

                            </Grid>
                            <Grid item xs={2.5}>
                                <TextField
                                    label="Folio"
                                    value={references[refIndex]?.folio || ""}
                                    onChange={(e) => handleUpdateReference(refIndex, "folio", e.target.value)}
                                    fullWidth
                                    size="small"
                                />

                            </Grid>
                            <Grid item xs={2.5}>
                                <TextField
                                    type="date"
                                    value={references[refIndex]?.date || ""}
                                    onChange={(e) => handleUpdateReference(refIndex, "date", e.target.value)}
                                    fullWidth
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    label="Razón"
                                    value={references[refIndex]?.reason || ""}
                                    onChange={(e) => handleUpdateReference(refIndex, "reason", e.target.value)}
                                    fullWidth
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <IconButton onClick={() => handleRemoveReference(refIndex)} size="small" color="error">
                                    ❌
                                </IconButton>
                            </Grid>
                        </>
                    ))}
                    <Button variant="outlined" onClick={() => handleAddReference()} fullWidth sx={{ mt: 1, ml: 2 }}>
                        Agregar Referencia
                    </Button>
                </>)}

                <Grid container justifyContent="center" spacing={5} sx={{ marginTop: '-15px' }}>
                    <Grid item>
                        <Button
                            id="btnBack"
                            sx={{
                                backgroundColor: '#ffffff',
                                border: '1px solid #516E80',
                                borderRadius: '10px',
                                color: '#516E80',
                                height: '25px',
                                padding: '6px 16px',
                                textTransform: 'none',
                                width: 200,
                                "&:hover": { backgroundColor: "#ffffff" }
                            }}
                            onClick={goBack}
                            disabled={status === ApiStatus.FETCHING}
                        >
                            Volver
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            id="btnSaveTicket"
                            sx={{
                                backgroundColor: '#516E80',
                                borderRadius: '10px',
                                color: '#ffffff',
                                height: '25px',
                                padding: '6px 16px',
                                textTransform: 'none',
                                width: 200,
                                "&:hover": { backgroundColor: "#516E80" }
                            }}
                            onClick={() => onConfirmTicket(idticket)}
                            disabled={loadingData || loadingSaveTicket || status === ApiStatus.FETCHING}
                        >
                            {loadingSaveTicket
                                ? <CircularProgress size={24} color="inherit" />
                                : 'Guardar pedido (F12)'}
                        </Button>
                    </Grid>

                    {!isClient && (
                        <Grid item>
                            <Button
                                id="btnIssueTicket"
                                sx={{
                                    backgroundColor: '#516E80',
                                    borderRadius: '10px',
                                    color: '#ffffff',
                                    height: '25px',
                                    padding: '6px 16px',
                                    textTransform: 'none',
                                    width: 200,
                                    "&:hover": { backgroundColor: "#516E80" }
                                }}
                                onClick={onCreateSalesDocument}
                                disabled={loadingData || loadingSaveTicket || status === ApiStatus.FETCHING}
                            >
                                {status === ApiStatus.FETCHING
                                    ? <CircularProgress size={24} color="inherit" />
                                    : 'Emitir (Ctrl + Enter)'}
                            </Button>
                        </Grid>
                    )}
                </Grid>
            </Grid>
            {
                showSaveSettingModal && (
                    <ModalConfirm
                        open={showSaveSettingModal}
                        closeModal={() => setShowSaveSettingModal(false)}
                        onConfirm={onSaveSetting}
                        status={statusSupplier === ApiStatus.FETCHING || statusTicket === ApiStatus.FETCHING}
                        title="El cliente no cuenta con información comercial. ¿Desea guardar la información seleccionada?"
                        text='Si estas seguro, haz click en el boton "aceptar"'
                    />
                )
            }
        </>
    )
}
